/**
 * Cleans the value provided by either defaulting it to a string if it's undefined/null, or
 * escaping the quotes in a string for double quotes.  This enables CSVs to process quotes properly, as per
 * https://tools.ietf.org/html/rfc4180#section-2.
 * @param str {string} String to be updated
 * @returns {string} String with all instances of double quotes doubled or empty string.
 */
export const cleanItemValue = (str: string): string => str ? str.replace(/"/g, '""') : '';
